export enum UserColorScheme {
  System = 'system',
  Light = 'light',
  Dark = 'dark',
}
